import AppContext from "context/Context";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Carousel, Container } from "react-bootstrap";
import styles from "./landing.module.css";
import { useTranslation } from "react-i18next";
import { GetFeatures } from "common/general";
import { useParams } from "react-router-dom";
import * as General from "common/general";

const LandingButtons = ({ img, text, rowSize, textColor }) => {
	const params = useParams();
	const filePath = params["*"];
	const safeAtob = (base64) => {
		try {
			// Remove any non-Base64 characters
			const cleaned = base64.replace(/[^A-Za-z0-9+/=]/g, "");
			return atob(cleaned);
		} catch (e) {
			console.error("Failed to decode base64:", e);
			return null;
		}
	};

	const createBlobUrlFromBase64 = (base64, extension) => {
		if (!base64) return null;

		const isPdf = extension === "pdf";
		const mimeType = isPdf ? "application/pdf" : `image/${extension}`;

		const byteCharacters = safeAtob(base64);
		if (!byteCharacters) return null;

		const byteArray = new Uint8Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteArray[i] = byteCharacters.charCodeAt(i);
		}

		const blob = new Blob([byteArray], { type: mimeType });
		return URL.createObjectURL(blob);
	};
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();
	const [features, setFeatures] = useState([]);
	useEffect(() => {
		let createdUrls = [];

		const fetchData = async () => {
			try {
				const response = await GetFeatures();
				if (response?.data?.dataBaseContent) {
					const mappedData = await Promise.all(
						response.data.dataBaseContent.map(async (item) => {
							const fileResponse = await General.GetPublicFile(item.image);
							const extension = item.image?.split(".").pop()?.toLowerCase();
							const blobUrl = createBlobUrlFromBase64(fileResponse.message, extension);
							if (blobUrl) createdUrls.push(blobUrl);

							return {
								title: item.title, // translate in render
								icon: blobUrl,
								description: item.description,
								id: item.id,
								order: item.order,
							};
						})
					);

					const sortedData = mappedData.sort((a, b) => a.order - b.order);
					setFeatures(sortedData);
				}
			} catch (error) {
				console.error("Error fetching features data:", error);
			}
		};

		fetchData();

		return () => {
			createdUrls.forEach((url) => URL.revokeObjectURL(url));
		};
	}, []);

	return (
		<Container className={`platform-info ${styles.padding35em}`}>
			<Row>
				{features.map((feature, index) => (
					<Col key={index} md={3} className="text-center">
						<div className={`icon ${styles.iconImages}`}>
							<img src={feature.icon} className={`icon ${styles.iconImagesMax}`} />
						</div>
						<h4 className={`icon ${styles.buttonsTitle} mb-3`} style={textColor ? { color: textColor } : undefined}>
							{t(feature.title)}
						</h4>
						{t(feature.description) && <p className={`icon ${styles.buttonsSubTitle}`}>{t(feature.description)}</p>}
					</Col>
				))}
			</Row>
		</Container>
	);
};

export default LandingButtons;
